export default {
  state: {
    dashboardRole: {},
  },

  mutations: {
    setDashboardRole(state, payload) {
      state.dashboardRole = payload;
    },
  },

  actions: {
    addDashboardRole: ({ commit }, payload) => {
      commit('setDashboardRole',  payload )
    },

  },
  
  getters: {
    dashboardRole: state => state.dashboardRole,
  },
}